const formWrapper = document.querySelector('.wcl-order-data-form');

if (formWrapper) {
   const selectTypeOfEmployment = formWrapper.querySelector('#order_type_of_employment');
   const formRows = formWrapper.querySelectorAll('.form-row-disabled');

   // Function for adding/removing attributes and classes
   function toggleInputState(input, enable) {
      if (input) {
         if (enable) {
            input.removeAttribute('disabled');
         } else {
            input.setAttribute('disabled', true);
         }
      }
   }

   // Add an event handler when the value of selectTypeOfEmployment changes
   selectTypeOfEmployment.addEventListener('change', function () {
      const selectedValue = this.value; // Get the selected value

      // Go through each block with the .form-row class
      formRows.forEach(formRow => {
         const input = formRow.querySelector('input');
         const inputName = input.getAttribute('name');

         // Depending on the selected value of selectTypeOfEmployment, we set or remove the disabled attribute of the inpute
         switch (selectedValue) {
            case 'employed':
               toggleInputState(input, inputName === 'order_job_title' || inputName === 'order_job_contract' || inputName === 'order_payslips');
               break;
            case 'self-employed':
               toggleInputState(input, inputName === 'order_job_title' || inputName === 'order_freelance_agreements' || inputName === 'order_invoices' || inputName === 'order_last_tax_return');
               break;
            case 'pensioner':
               toggleInputState(input, inputName === 'order_previous_occupation' || inputName === 'order_proof_of_earnings_of_pension');
               break;
            case 'living-on-investments-rents':
               toggleInputState(input, inputName === 'order_type_of_income' || inputName === 'order_document_origin_of_money' || inputName === 'order_last_tax_return');
               break;
            default:
               toggleInputState(input, false);
         }

         // Update the form row state
         if (input.getAttribute('disabled')) {
            formRow.classList.add('form-row-disabled');
         } else {
            formRow.classList.remove('form-row-disabled');
         }
      });
   });

   // Check cookies on page load and restore the state of the active inpute
   window.addEventListener('load', function () {
      // Go through each block with the .form-row class
      formRows.forEach(formRow => {
         const input = formRow.querySelector('input');
         const inputName = input.getAttribute('name');

         // Depending on the selected value of selectTypeOfEmployment, we set or remove the disabled attribute of the inpute
         switch (selectTypeOfEmployment.value) {
            case 'employed':
               toggleInputState(input, inputName === 'order_job_title' || inputName === 'order_job_contract' || inputName === 'order_payslips');
               break;
            case 'self-employed':
               toggleInputState(input, inputName === 'order_job_title' || inputName === 'order_freelance_agreements' || inputName === 'order_invoices' || inputName === 'order_last_tax_return');
               break;
            case 'pensioner':
               toggleInputState(input, inputName === 'order_previous_occupation' || inputName === 'order_proof_of_earnings_of_pension');
               break;
            case 'living-on-investments-rents':
               toggleInputState(input, inputName === 'order_type_of_income' || inputName === 'order_document_origin_of_money' || inputName === 'order_last_tax_return');
               break;
            default:
               toggleInputState(input, false);
         }

         // Update the form row state
         if (input.getAttribute('disabled')) {
            formRow.classList.add('form-row-disabled');
         } else {
            formRow.classList.remove('form-row-disabled');
         }
      });
   });
}